
export const UrlActionTypes = {
  SET_UNPUBLISHED_URLS: 'SET_UNPUBLISHED_URLS',
  SET_FILTERED_URLS: 'SET_FILTERED_URLS',
  SET_URL_AS_REVIEWED: 'SET_URL_AS_REVIEWED',
  SET_URL_AS_IGNORED: 'SET_URL_AS_IGNORED',
  SET_FILTERED_URL_AS_REVIEWED: 'SET_FILTERED_URL_AS_REVIEWED',
  SET_FILTERED_URL_AS_IGNORED: 'SET_FILTERED_URL_AS_IGNORED',
  REMOVE_IGNORED_URLS: 'REMOVE_IGNORED_URLS',
  SET_PUBLISH_NOTIFICATION_SUMMARY: 'SET_PUBLISH_NOTIFICATION_SUMMARY',
  SET_PUBLISH_SUMMARY: 'SET_PUBLISH_SUMMARY',
  SET_REVISED_CATEGORY: 'SET_REVISED_CATEGORY',
  SET_FILTERED_URL_REVISED_CAT: 'SET_FILTERED_URL_REVISED_CAT'
};